import { getTextStyles, squareBlockCSS, styledOmitCustomProps } from '@braskai/ui-kit';

import {
  css,
  ListItem,
  ListItemButton,
  listItemIconClasses,
  ListItemText,
  listItemTextClasses,
  styled,
} from '@mui/material';

export const SListItem = styled(ListItem)(
  () => css`
    margin-top: 4px;
    margin-bottom: 4px;
  `,
);

type SListItemButtonProps = {
  $isDisabled?: boolean;
  $isMainMenu?: boolean;
  $isMobile?: boolean;
  $isOutlined?: boolean;
  $isSquare?: boolean;
};

export const SListItemButton = styled(
  ListItemButton,
  styledOmitCustomProps,
)<SListItemButtonProps>(
  ({ theme, $isMobile, $isDisabled, $isMainMenu, $isOutlined, $isSquare }) => css`
    display: flex;
    flex-direction: row;
    border-radius: 10px;
    padding: 10px 12px;
    height: 44px;
    min-width: 44px;
    color: ${theme.palette.grey[$isMainMenu ? 900 : 700]};

    ${$isSquare &&
    css`
      ${squareBlockCSS(44)};
    `}

    ${$isMobile &&
    css`
      color: ${theme.palette.grey[900]};
      border: 1px solid ${theme.palette.grey[200]};
    `}

    ${$isOutlined &&
    css`
      justify-content: center;
      color: ${theme.palette.grey[900]};
      background-color: ${theme.palette.common.white};
      border: 1px solid ${theme.palette.grey[300]};
      border-radius: 8px;

      & > .${listItemTextClasses.root} {
        flex: 0 1 auto;
        text-align: center;
      }
    `}

    &.Mui-selected {
      color: ${theme.palette.grey[900]};
      background-color: ${theme.palette.grey[50]};
    }

    &:hover,
    &.Mui-selected:hover {
      background-color: ${theme.palette.grey[25]};
    }

    & > .${listItemIconClasses.root} {
      color: currentColor;
      min-width: 20px;
    }

    & > .${listItemTextClasses.root} > .${listItemTextClasses.primary} {
      color: currentColor;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      ${getTextStyles('body-2-md')}
    }

    ${$isDisabled &&
    css`
      color: ${theme.palette.grey[300]};
      pointer-events: none;
    `}

    ${theme.breakpoints.up('tablet')} {
      height: 40px;
      min-width: 40px;
    }
  `,
);

export const SListItemText = styled(ListItemText)(
  () => css`
    ${getTextStyles('body-2-md')}
    display: flex;
    justify-content: space-between;

    .${listItemTextClasses.secondary} {
      color: currentColor;
    }
  `,
);
